import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import * as _ from 'underscore';
import {Flat} from '../../../models/flat.model';
import {FlatArea} from '../../../models/flat-area.model';
import {FlatUtilService} from '../../../util/flat-util.service';

@Component({
  selector: 'app-flat-preview-item',
  templateUrl: './flat-preview-item.component.html',
  styleUrls: ['./flat-preview-item.component.scss']
})
export class FlatPreviewItemComponent implements OnInit {

  @Input() flat: Flat;

  constructor(private router: Router,
              private flatUtil: FlatUtilService) {
  }

  ngOnInit() {

  }


  openFlatPage(flat) {
    if (flat.soldOut) {
      return;
    }
    this.router.navigateByUrl('/flat/' + flat.id);
  }


  getTerraceSize(flat) {
    return this.flatUtil.getTerraceSize(flat);
  }

  removeHuf(priceString) {
    return priceString.replace('HUF', '');
  }


}
